/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import * as s from './style'

const YearDisplay = ({ yearArray, selectedYear }) => {

    return (
        <div css={s.yearContainer}>
            {yearArray?.map((year) => (
                <div key={year} css={[s.year, selectedYear === year? s.activeYear : ""]}>{year}</div>
            ))}
        </div>
    );
};

export default YearDisplay;